<template>
  <div>
    <IsiTeksSub halaman="materi2" :sub="id" />
  </div>
</template>

<script>
import IsiTeksSub from '../components/IsiTeksSub'

export default {
  computed: {
    id: function() {
      return this.$route.params.id
    }
  },
  mounted() {
    
  },
  components: {
    IsiTeksSub
  }
}
</script>